export default "__VITE_PUBLIC_ASSET__0125caf5__"